import { PAYEX_URL } from 'constants/config';
import { decamelizeKeys } from 'humps';
import { fetchJson } from 'utils/fetchJson/fetchJson';

import type {
  SendOtpParams,
  SendOtpResponse,
  VerifyOtpParams,
  VerifyOtpResponse,
} from './types';

export const otp = {
  send: (params: SendOtpParams) => {
    const path = `${PAYEX_URL}/otp`;
    const body = JSON.stringify(decamelizeKeys(params));

    return fetchJson<SendOtpResponse>(path, { method: 'POST', body });
  },

  verify: (params: VerifyOtpParams) => {
    const path = `${PAYEX_URL}/otp/verify`;
    const body = JSON.stringify(decamelizeKeys(params));

    return fetchJson<VerifyOtpResponse>(path, { method: 'POST', body });
  },
};
